import { PageConfig } from "../page-configs";
import { AlertId, getAlert } from "../alert";
import { DISCLAIMER } from "../../../global/variables";
import { getWelcomeText } from "../welcome";
import { FAMKA_BUTTONS } from "../../feature-buttons";

export const pageConfigFamka: PageConfig = {
    header: "Digitaler Assistent",
    alert: getAlert(AlertId.QuestionsAboutKindergeldOrKinderzuschlag),
    welcome: {
        text: getWelcomeText("FAMKA"),
        disclaimer: DISCLAIMER,
        buttons: FAMKA_BUTTONS,
    },
};
